module.exports = __webpack_public_path__ + "img/mp-node-state.1425bec8.jpg";